import { QueryClient } from '@tanstack/react-query'
import { createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'

// Create a single QueryClient instance that will be shared everywhere
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Global defaults for all queries
      staleTime: 1000 * 60, // 1 minute - data is considered fresh for 1 minute
      gcTime: 1000 * 60 * 5, // 5 minutes - unused data is garbage collected after 5 minutes
      retry: (failureCount, error: any) => {
        // Don't retry on auth errors
        if (error?.response?.status === 401) return false
        // Retry server errors up to 1 time
        if (error?.response?.status >= 500) return failureCount < 1
        // Retry other errors once
        return failureCount < 1
      },
      refetchOnWindowFocus: false, // Disable refetch on window focus
      networkMode: 'offlineFirst', // Better offline support
    },
    mutations: {
      // Global defaults for all mutations
      retry: false, // Don't retry mutations
    },
  },
})

// Create router using the shared QueryClient
export const router = createRouter({
  routeTree,
  context: {
    queryClient, // Use the shared instance
    auth: undefined!, // This will be set after we wrap the app in an AuthProvider
  },
  defaultPreload: 'intent',
  scrollRestoration: true,
})

// Type registration for TypeScript
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}